import { useEffect, useRef, useState } from "react";

const LanguageSelect = ({ field, form, options, placeholder, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedLanguage = options.find(lang => lang.id.toString() === field.value?.toString());
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (language) => {
    form.setFieldValue(field.name, language.id);
    setIsOpen(false);
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      {/* Custom dropdown trigger */}
      <div
        className="form-control d-flex align-items-center"
        style={{ 
          cursor: 'pointer',
          paddingLeft: '40px',
          backgroundImage: selectedLanguage?.imagePath 
            ? `url(${process.env.REACT_APP_FLAG_IMAGE_PATH}${selectedLanguage.imagePath})`
            : 'none',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left 12px center',
          backgroundSize: '20px 15px',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedLanguage ? (
          <span>{selectedLanguage.name}</span>
        ) : (
          <span className="text-muted">{placeholder}</span>
        )}
        <span className="ms-auto">▼</span>
      </div>

      {/* Selected flag overlay */}
      {selectedLanguage?.imagePath && (
        <img 
          src={`${process.env.REACT_APP_FLAG_IMAGE_PATH}${selectedLanguage.imagePath}`}
          alt={selectedLanguage.name}
          style={{
            position: 'absolute',
            left: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '20px',
            height: '15px',
            pointerEvents: 'none'
          }}
        />
      )}

      {/* Custom dropdown options */}
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '4px',
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: 1000,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        >
          {/* Placeholder option */}
          <div
            className="p-2 border-bottom"
            style={{ cursor: 'pointer' }}
            onClick={() => handleSelect({ id: '' })}
          >
            <span className="text-muted">{placeholder}</span>
          </div>

          {/* Language options with flags */}
          {options.map((language) => (
            <div
              key={language.id}
              className="p-2 border-bottom d-flex align-items-center"
              style={{ 
                cursor: 'pointer',
                backgroundColor: selectedLanguage?.id === language.id ? '#f8f9fa' : 'white'
              }}
              onClick={() => handleSelect(language)}
            >
              {language.imagePath && (
                <img 
                  src={`${process.env.REACT_APP_FLAG_IMAGE_PATH}${language.imagePath}`}
                  alt={language.name}
                  style={{
                    width: '20px',
                    height: '15px',
                    marginRight: '8px'
                  }}
                />
              )}
              <span>{language.name}</span>
            </div>
          ))}
        </div>
      )}

      {/* Hidden native select for form submission */}
      <select
        {...field}
        {...props}
        style={{ display: 'none' }}
      >
        <option value="">{placeholder}</option>
        {options.map((language) => (
          <option key={language.id} value={language.id}>
            {language.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelect;
